import { prop } from "@suse-o11y/prop";
import { useComputed } from "@suse-o11y/signal";
import type { SignalForm } from "@suse-o11y/signal/form";
import { useDelayed } from "@suse-o11y/use-delayed";
import { z } from "zod";

const errorSchema = z.union([
	// take the first string from an array of strings
	z.array(z.string()).min(1).transform(prop(0)),
	z.string(),
]);

/**
 * The error message displayed when no other FormMessage.variant=error are present in the same FormField.
 */
export const useFormFieldDelayedError = (state: SignalForm): null | string => {
	const errorMessage = useComputed(
		(monitor) => {
			const result = errorSchema.safeParse(state.getError(monitor));

			if (result.success) {
				return result.data;
			}

			return null;
		},
		[state],
	);

	// show the error with a delay of 200ms to allow other user events to process before the layout shift
	const delayedErrorMessage = useDelayed(errorMessage, 200);

	// do not delay when errorMessage is null
	if (delayedErrorMessage == null || errorMessage == null) {
		return null;
	}

	return delayedErrorMessage;
};
